const { localPorts } = require('../localPorts.config');

const domain = 'localhost';

module.exports = {
    API: '/api',
    CDN: '',
    DOMAIN: domain,
    CDN_ROOT: 'https://cdn.r1s-dev.com',
    SITE_ROOT: `http://${domain}:${localPorts.navigation}`,
    MAPBOX_ACCESS_TOKEN: 'pk.eyJ1IjoicjFzLXRvb2xzIiwiYSI6ImNqeW9veHpzZzE3NHozY2xtbnBlcm5qc2cifQ.bz7F12o1jRLFKEwpn0A51A',
    MAPBOX_STYLE: 'mapbox://styles/r1s-tools/cj8oscb788yzr2sr83f3pqj3f',
    MAPBOX_STATIC_STYLE: 'https://api.mapbox.com/styles/v1/r1s-tools/cj8oscb788yzr2sr83f3pqj3f/static',
    GTM_EXT_ID: 'GTM-5PH9PJ3',
    NODE_ENV: 'development',
    NODE_PATH: '../node_modules',
    PRS_APP_ID: 'qhag7hW3XgU-rzO2_E0XK',
    PRS_API: 'https://prs.payments.r1s-dev.com/api',
    SN_API: 'https://recreationonestopdev.servicenowservices.com/api',
    SN_CHAT_URL: 'https://recreationonestopdev.servicenowservices.com/$chat_support.do?queueID=118ba22cdb1c23009bf57d0e0f961917',
    SN_INTERNAL_CHAT_URL: 'https://recreationonestopdev.servicenowservices.com/$chat_support.do?queueID=6cae70261bd4dc10ce2010ad9c4bcbf3',
    SN_KB_EXT_URL: 'https://recreationonestopdev.servicenowservices.com/external',
    SN_KB_INT_URL: 'https://recreationonestopdev.servicenowservices.com/internalhub',
    SN_CONTACT_EXT_URL: 'https://recreationonestopdev.servicenowservices.com/external?id=external_contact_us',
    SN_CONTACT_INT_URL: "https://recreationonestopdev.servicenowservices.com/internalhub?id=contact_us",
    SN_CASES_URL: 'https://recreationonestopdev.servicenowservices.com/csp?id=customer_case',
    REACT_AXE_ENV: 'local',
    RECAPTCHA_SITE_KEY: '6LdGlW4UAAAAAO2hyCDSoWAdiUUaVf3OLltRHxBw',
    RECAPTCHA_ENTERPRISE_KEY: '6LeKpdMZAAAAACOW33cW6Xd0o5k1IHkiYL1sTuqX',
    RECAPTCHA_ENTERPRISE_KEY_INVIS: '6LdtZd8ZAAAAAAUKC1FHvFKwv9jI6bHrSYn9uPcp',
    RECAPTCHAV3_SITE_KEY: '6LevB4gUAAAAAMIokR6-H8X0lROfYtfspBeMLwsY',
    // // map that entiry and action must match with what's in the helper Builder.
    FEATURES: {
        gaECommerce: true,
        receipt: true,
        closures: {
            permit: true,
            tickets: true,
            ticketsTaskListName: "local_ticket_inventory_closures_worker"
        },
        reservations_listing: true
    },
    LAUNCH_DARKLY_KEY: '5e51679cae2dad07c0376166',
    DIALOGFLOW_AGENT_ID: '340392ec-e0d5-4503-a02a-75909c334742'
};
